module.exports = __webpack_public_path__ + "img/BTC.402459a6.png";